import { useSelector } from 'react-redux';
import ActivityForm from './ActivityForm';
//
// Компонент для создания мероприятия
//
const ActivityAdd = () => {
    const exhibitor = useSelector(state => state.exhibitor);
    return (
		<ActivityForm exhibitor={exhibitor} activity={null}/>
	);
};

export default ActivityAdd;
